import React from 'react'
import { withParsedContext } from '../../withJSSContext'
import { LotTile } from '@christies/react/components/Tiles'
import { RelatedTileCarousel, LotTileSkeleton } from '@christies/react/components/Magazine'
import { track, TrackingEvents } from '@christies/react/utils'
import { ResponsiveValue, Spacers } from '@christies/react/foundations'
import { useRelatedLotsData } from './useRelatedLotsData'
import { MagazinesRelatedLotsModuleProps } from './types'

const MagazinesRelatedLotsModule: React.FC<MagazinesRelatedLotsModuleProps> = ({
  parsedFields,
  parsedRouteFields,
  parsedSitecoreContext,
  t,
}) => {
  const storyAPIEndpoint = parsedSitecoreContext['Discovery.Feature.Magazines.StoriesByIdApiDefinition']

  const lotAPIEndpoint = parsedFields['lots_endpoint']
  const psItemEndpoint = parsedFields['ps_items_search_endpoint']
  const lotsLiveUrlFormat = parsedFields['lots_live_url_format']
  const lotsOnlineUrlFormat = parsedFields['lots_online_url_format']
  const psItemUrlFormat = parsedFields['ps_item_url_format']

  const { data, status } = useRelatedLotsData(
    {
      storyAPIEndpoint,
      lotAPIEndpoint,
      psItemEndpoint,
      lotsOnlineUrlFormat,
      lotsLiveUrlFormat,
      psItemUrlFormat,
    },
    import('./mock')
  )

  const carouselProps = {
    t: {
      previousButtonAriaLabel: t('feature-discovery-magazines-quickview-previousbuttonarialabel'),
      nextButtonAriaLabel: t('feature-discovery-magazines-quickview-nextbuttonarialabel'),
      slideDividerLabel: t('feature-discovery-magazines-quickview-sliderpagenumberparticle'),
    },
    theme: parsedRouteFields?.['Story Theme']?.key,
    title: parsedFields?.['Heading'],
    tileWidth: {
      xs: 296,
      xl: 252,
      xxl: 300,
    },
    gap: { xs: 'spacer5', sm: 'spacer6', xxl: 'spacer7' } as ResponsiveValue<Spacers>,
    loadingComponent: <LotTileSkeleton />,
  }

  const getAnalytics = (_e: React.MouseEvent, index: number): void => {
    track({
      event: TrackingEvents.INTERACTION,
      data: {
        interaction: {
          type: `lot:${index}`,
          location: t('feature-discovery-magazines-relatedlots-analytics-location', {
            defaultValue: 'stories:related lots',
          }),
          destination: 'lot',
        },
      },
    })
  }

  return (
    <RelatedTileCarousel {...carouselProps} componentStatus={status}>
      {(data || []).map((lot, index: number) => (
        <LotTile
          key={index.toString()}
          handleChange={(e: React.MouseEvent): void => getAnalytics(e, index + 1)}
          {...lot}
        />
      ))}
    </RelatedTileCarousel>
  )
}

export default withParsedContext(MagazinesRelatedLotsModule as React.FC)
